<template>
  <div class="dashboard__wrapper" :class="{ sideOpen: sidebarShown }">
    <MainSidebar
      :sidebarShown="sidebarShown"
      :chosenWidget="chosenWidget"
      :userWidgets="userWidgets"
      :toggleSidebar="toggleSidebar"
      :closeSidebar="closeSidebar"
      :getChosenWidget="getChosenWidget"
      :deleteWidget="deleteWidget"
      :editWidget="editWidget"
    />

    <div class="db-main-panel">
      <top-navbar
        :sidebar-shown="sidebarShown"
        :set-chosen-null="setChosenNull"
        :toggleSidebar="toggleSidebar"
      />

      <dashboard-content> </dashboard-content>

      <div
        v-if="
          $route.path === '/user/create_bot' ||
          $route.path === '/user/bot_settings'
        "
        class="footer_bot_cont"
      >
        <div
          v-show="
            $route.path === '/user/create_bot' ||
            $route.path === '/user/bot_settings'
          "
          class="footer_bot"
        >
          <!-- <ButtonWithLoadWebsite
            class="footer_bot_btn"
            title="Fetch additional links"
          /> -->

          <router-link
            v-if="$route.path === '/user/create_bot'"
            to="/user/bot_settings"
          >
            <ButtonWithLoadWebsite
              @onClick="sendAnalyticEvent('create_bot_parsing_next_button_click')"
              class="footer_bot_btn"
              title="Next"
              :isDisabled="secondStepDisabled"
            />
          </router-link>

          <ButtonWithLoadWebsite
            v-if="$route.path === '/user/bot_settings'"
            class="footer_bot_btn"
            title="Start Training"
            :isDisabled="createBotDisabled || isLoading"
            @onClick="createBot"
          />
        </div>
      </div>
    </div>

    <ChatBotDemo
      v-show="chosenWidget && !demoDisabled"
      :botSettings="{
        ...chosenWidget?.settings,
        ...chosenWidget?.brains?.users,
        token: chosenWidget?.token,
        id: chosenWidget?.id,
      }"
    />
    <Loader :loading="isDataLoading" v-show="isLoading" />
  </div>
</template>

<script>
import vClickOutside from "v-click-outside";
import ChatBotDemo from "../components/ChatBotDemo/ChatBotDemo.vue";
import DashboardDropdown from "../components/DashboardDropdown.vue";
import ButtonWithLoadWebsite from "../components/shared/ButtonWithLoadWebsite.vue";
import Loader from "../components/shared/Loader/Loader.vue";
import Modal from "../components/shared/Modal/Modal.vue";
import { DataService } from "../config/dataService";
import localUser from "../js/helpers/localUser";
import store from "../vuex/store.js";
import DashboardContent from "./Content.vue";
import ContentFooter from "./ContentFooter.vue";
import MainSidebar from "./MainSidebar.vue";
import MobileMenu from "./MobileMenu.vue";
import TopNavbar from "./TopNavbar.vue";
const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    Modal,
    TopNavbar,
    Loader,
    ContentFooter,
    DashboardContent,
    MobileMenu,
    ButtonWithLoadWebsite,
    DashboardDropdown,
    ChatBotDemo,
    MainSidebar,
  },
  data() {
    return {
      sidebarShown: false,
      isDataLoading: false
    };
  },
  computed: {
    isLoading() {
      return this.isDataLoading || store.getters.isLoading;
    },
    demoDisabled() {
      return (
        this.$route?.path?.includes("user/create_bot") ||
        this.$route?.path?.includes("user/bot_settings") ||
        this.$route?.path?.includes("user/appearance")
      );
    },
    chosenWidget() {
      return store?.state?.users?.chosenWidget;
    },
    userWidgets() {
      return store?.state?.users?.widgets || [];
    },
    createBotData() {
      return store?.state?.createBotData?.data;
    },
    secondStepDisabled() {
      const { websiteLink, links } = this.createBotData;
      return websiteLink === "" ? true : links.length === 0 ? true : false;
    },
    createBotDisabled() {
      const { name, linkType, welcomeMessage, botIcon } = this.createBotData;

      return name === "" || linkType === "" || welcomeMessage === "" || !botIcon
        ? true
        : false;
    },
  },
  methods: {
    sendAnalyticEvent(event) {
      gtag('event', event, {});
      amplitude.getInstance().logEvent(event, {});
    },
    logOut() {
      store.dispatch("logout");
    },
    toggleSidebar() {
      this.sidebarShown = !this.sidebarShown;
    },
    closeSidebar(e) {
      if ((this.sidebarShown = false || e?.target?.id === "burger")) {
        return;
      }
      this.sidebarShown = false;
    },
    async createBot() {
      const {
        websiteLink: link,
        links: sources,
        linkType: type,
        botIcon,
        userIcon,
        agentIcon,
        ...settings
      } = this.createBotData;

      const botData = {
        settings: JSON.stringify(settings),
        link,
        sources,
        type,
        botIcon,
        userIcon,
        agentIcon,
      };

      const formData = new FormData();

      Object.keys(botData).forEach((key) => {
        const value = botData[key];

        if (value === "" || value === null) {
          return;
        }

        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            formData.append(`${key}[${index}]`, item);
          });
        } else {
          formData.append(key, value);
        }
      });

      try {
        store.dispatch("startLoading");
        const result = await DataService.post(
          `${API_ENDPOINT}widget/add`,
          formData,
          { "Content-Type": "multipart/form-data" }
        );

        if (result && result?.data) {
          // this.getChosenWidget(result.data.id);

          store.dispatch("setChosen", result?.data);
          store.dispatch("setChatHistory", []);
          store.dispatch("setWidgets", [
            ...this.userWidgets,
            {
              id: this.chosenWidget?.id,
              name: this.chosenWidget?.settings?.name,
            },
          ]);
          localStorage.setItem('chosenWidget', this.chosenWidget?.id);

          this.clearLocalBotData();
          this.$router.replace("/user/dashboard");
          this.$toast.success(
            "Widget successfully created! To be able to train and use the bot, purchase a subscription in the Billing section."
          );
        }
      } catch (error) {
        const errorMessage = error?.response?.data?.errorDescription === "Access is denied. Contact support"
          ? 'To create an additional chatbot, upgrade your plan'
          : error?.response?.data?.errorDescription || "Bot creation error";
        this.$toast.error(errorMessage);
      } finally {
        store.dispatch("endLoading");
        gtag('event', 'create_bot_custom_start_training_button_click', {});
        amplitude.getInstance().logEvent('create_bot_custom_start_training_button_click', {});
      }
    },
    clearLocalBotData() {
      const botDataKeys = ["botData", "botDataSelectedLinks", "botSettings"];
      botDataKeys.forEach((value) => localStorage.removeItem(value));
    },
    async getStart() {
      try {
        store.dispatch("startLoading");
        const chosen = localStorage.getItem("chosenWidget");

        await DataService.get(`${API_ENDPOINT}widget`).then((result) => {

          if (chosen && result?.data?.widgets?.length <= 0) {
                this.logOut();
            };

          if (result?.data?.widgets?.length > 0) {
            store.dispatch("setWidgets", result?.data?.widgets);
            store.dispatch(
              "setTotalMessagesCount",
              result?.data?.totalMessagesCount
            );

            if (chosen) {
              this.getChosenWidget(chosen);
            } else {
              this.getChosenWidget(this.userWidgets[0]?.id);
            }
          } else {
            if (!this.$route?.path?.includes("user/chatbots")) {
              this.$router.push({ path: "/user/chatbots" });
            }
          }
        });
      } catch (error) {
        console.log(error);
        this.$toast.error(
          error?.response?.data?.errorDescription || "Something went wrong"
        );
      } finally {
        store.dispatch("endLoading");
      }
    },
    async getChatHistory(id) {
      try {
        const user = localUser.getLocalUser(id);
        if (!user) {
          return store.dispatch("setChatHistory", []);
        }

        const { data } = await DataService.get(
          `${API_ENDPOINT}history/widget/${id}/user/${user}`
        );

        store.dispatch("setChatHistory", data.messages);
      } catch (error) {
        store.dispatch("setChatHistory", []);
        console.log(error);
      }
    },
    async getChosenWidget(id) {
      try {
        this.isDataLoading = true;

        const { subscription } = this.$route.query;
        let url = `${API_ENDPOINT}widget/get-by-id/${id}`;
        if (subscription === 'success') {
          url = url.concat('?withInvoice=true');
        }
        await DataService.get(url).then(
          (result) => {
            store.dispatch("setChosen", result?.data);
            localStorage.setItem("chosenWidget", id);
            this.sidebarShown = false;

            if (
              this.$route?.path?.includes("user/chatbots") ||
              this.$route?.path?.includes("user/create_bot") ||
              this.$route?.path?.includes("user/bot_settings")
            ) {
              this.$router.push({ path: "/user/dashboard" });
            }
            
            this.getChatHistory(this.chosenWidget.id);
            
            if (subscription === 'success') {
              const subInfo = result?.data?.owner?.subscription;

              gtag('event', 'purchase', {
                sub_type: subInfo?.sub_type,
                amount: !isNaN(subInfo?.amount) ? subInfo?.amount / 100 :  null
              });
              amplitude.getInstance().logEvent('purchase', {
                sub_type: subInfo?.sub_type,
                amount: !isNaN(subInfo?.amount) ? subInfo?.amount / 100 :  null
              });
            }
          }
        );
      } catch (error) {
        this.setChosenNull();
        this.getStart();
        console.log(error);
        this.$toast.error(
          error?.response?.data?.errorDescription || "Get chosen widget error"
        );
      } finally {
        this.isDataLoading = false;
      }
    },
    setChosenNull() {
      localStorage.removeItem("chosenWidget");
      store.dispatch("setChosen", null);
    },
    async deleteWidget(widgetId) {
      try {
        store.dispatch("startLoading");

        const response = await DataService.delete(`widget/delete/${widgetId}`);

        if (response?.data?.status === true) {
          if (widgetId == this.chosenWidget?.id) {
            this.setChosenNull();
          }
          store.dispatch("deleteOneOfWidgets", widgetId);
          this.$toast.success("Widget deleted :(");

          if (this.userWidgets.length > 0) {
            this.getChosenWidget(this.userWidgets[0]?.id);
          } else {
            this.$router.replace("/user/chatbots");
          }
        } else {
          this.$toast.error(
            "Widget dose not exist, or you have no rights to delete it"
          );
        }
      } catch (error) {
        console.log(error);
        this.$toast.error(
          error?.response?.data?.errorDescription || "Delete widget error"
        );
      } finally {
        store.dispatch("endLoading");
      }
    },
    async editWidget(widgetId, name) {
      try {
        store.dispatch("startLoading");

        const response = await DataService.patch(`widget/rename/${widgetId}`, { name });
        store.dispatch("updateChosen", response?.data);
        const updatedWidgets = this.userWidgets.map(w => {
          if (w.id === response?.data?.id) {
            return {
              id: response?.data?.id,
              name: response?.data?.settings?.name,
            }
          } else {
            return w
          }
        });
        store.dispatch("setWidgets", updatedWidgets);
        this.$toast.success("Widget edited successfully");
      } catch (error) {
        console.log(error);
        this.$toast.error(
          error?.response?.data?.errorDescription || "Edit widget error"
        );
      } finally {
        store.dispatch("endLoading");
      }
    },
  },
  mounted() {
    this.getStart();
  },
};
</script>

<style scoped lang="scss">
.dashboard__wrapper {
  max-height: 100vh;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  overflow-y: auto;
  overflow-x: hidden;
  transition: all 150ms linear;

  @media (min-width: 1480px) {
    grid-template-columns: 280px 1fr;
  }
}

.db-main-panel {
  position: relative;
  width: 100%;
  height: 100vh;
}

.footer_bot_btn {
  height: 46px;
  width: 174px;
}
.footer_bot {
  padding: 17px 128px;
  display: flex;
  justify-content: flex-end;
}
.footer_bot_cont {
  position: absolute;
  background: #fff;
  box-shadow: 0px -4px 10px 0px rgba(0, 0, 0, 0.03);
  width: 100%;
  right: 0;
  /* height: 119px; */
  bottom: 0;
  backdrop-filter: blur(10px);
  /* position: fixed; */
  border-top: 1px solid #e7e7e7;
}
</style>
